module.exports = "<wow-shelf-bundle bundle=\"bundle\"\r\n                  initial-product=\"bundle.Products[0].Stockcode\"\r\n                  flipped=\"flipped\">\r\n</wow-shelf-bundle>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/shelfproduct/bundle-template.html
 ** module id = 44
 ** module chunks = 1 7 10
 **/